import React, { CSSProperties, FC } from 'react'
import type { WidgetLoadingSpinnerProps } from './widget-loading-spinner.d'
import styles from './widget-loading-spinner.module.scss'

export const WidgetLoadingSpinner: FC<WidgetLoadingSpinnerProps> = ({
  color = '#12C75D',
  backgroundColor = '#6DF7A6',
}) => {
  const loadingSpinnerClass: CSSProperties = {
    border: `5px solid ${backgroundColor}`,
    borderTop: `5px solid ${color}`,
  }

  return <div className={styles['root']} style={loadingSpinnerClass}></div>
}
